import api from './baseApi';
import { DTO } from '@extTypes/dto/productDto';

export const getProducts = async (
    searchString: string,
    from: number,
    limit: number,
    includeVariants: boolean,
    linkedProducts: string,
    store: string
): Promise<DTO.ProductsListingApiResponse> => {
    const response = await api.get('products', {
        params: {
            searchString: searchString,
            from: from,
            limit: limit,
            includeVariants: includeVariants,
            linkedProducts: linkedProducts,
            shop: store
        }
    });
    return response.data;
};

export const saveProduct = async (productId: string, product: Partial<DTO.Product.Product>, store: string) => {
    product.id = productId;
    const response = await api.put('products', product, {
        params: {
            shop: store
        }
    });
    return response.data;
};

export const startProductSync = async (store: string) => {
    const response = await api.put(
        'products/status',
        {
            status: 'sync'
        },
        {
            params: {
                shop: store
            }
        }
    );
    return response.data;
};

export const getProductsStatus = async (
    store: string
): Promise<{
    synchronization: 'error' | 'completed' | 'synchronizing' | 'unknown';
}> => {
    const response = await api.get('products/status', {
        params: {
            shop: store
        }
    });
    return response.data;
};

export const getProduct = async (id: string, store: string): Promise<DTO.Product.Product> => {
    const response = await api.get('products/' + id, {
        params: {
            shop: store
        }
    });
    return response.data;
};

export const getProductUrl = async (id: string, store: string): Promise<{ url: string }> => {
    const response = await api.get(`products/${id}/url`, {
        params: {
            shop: store
        }
    });
    return response.data;
};

export const startImportProductsConfig = async (store: string) => {
    const response = await api.put(
        'products/config/status',
        {
            status: 'importing'
        },
        {
            params: {
                shop: store
            }
        }
    );
    return response.data;
};

export const getProductsConfigImportStatus = async (
    store: string
): Promise<{
    import: 'error' | 'completed' | 'importing' | 'unknown' | 'not-imported';
}> => {
    const response = await api.get('products/config/status', {
        params: {
            shop: store
        }
    });
    return response.data;
};
